import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';

export const getProjectLastPublishedQueryKey = (locator: string): QueryKey => ['projects', locator, 'last-published'];

/**
 * Query for the date a project or revision was last published.
 *
 * @param {string} locator - A project or revision locator. No need to call nuc before passing it in here.
 */
export function useProjectLastPublished(locator: string) {
  return useQuery<string>({
    queryKey: getProjectLastPublishedQueryKey(locator),
    queryFn: () => get<string>(`/api/projects/${nuc(locator)}/last-published`),
  });
}
